module.exports = __webpack_public_path__ + "img/20.da7dc898.jpg";